export const POST_CREATE = 'POST_CREATE';
export const POST_CREATE_RESULT = 'POST_CREATE_RESULT';

export const POST_UPDATE = 'POST_UPDATE';
export const POST_UPDATE_REQUEST = 'POST_UPDATE_REQUEST';
export const POST_UPDATE_RESULT = 'POST_UPDATE_RESULT';

export const POST_INFO_GET = 'POST_INFO_GET'
export const POST_INFO_GET_RESULT = 'POST_INFO_GET_RESULT'

export const POST_INFO_REMOVE = 'POST_INFO_REMOVE'

export const POST_DESTROY = 'POST_DESTROY'
export const POST_DESTROY_RESULT = 'POST_DESTROY_RESULT'
export const POST_DESTROY_FLAG_REMOVE = 'POST_DESTROY_FLAG_REMOVE'

export const POST_COMMENT_CREATE = 'POST_COMMENT_CREATE'
export const POST_COMMENT_CREATE_RESULT = 'POST_COMMENT_CREATE_RESULT'
export const POST_COMMENT_UPDATE = 'POST_COMMENT_UPDATE'
export const POST_COMMENT_UPDATE_RESULT = 'POST_COMMENT_UPDATE_RESULT'
export const POST_COMMENT_DESTROY = 'POST_COMMENT_DESTROY'
export const POST_COMMENT_DESTROY_RESULT = 'POST_COMMENT_DESTROY_RESULT'


// WEBPACK FOOTER //
// ./src/constants/Post.js